export const toggleViews = () => {

    const btnToggleView = '.js-toggle-view';
    let toggled = false;

    const init = () => {
      bind();
    };
  
    const bind = () => {
  
      $(btnToggleView).on('click', function(e) {
        e.preventDefault();
        // const element = $(this).data('href');
        toggled = !toggled;
     
        $('.js-view').attr('data-list-view', $('.js-view').attr('data-list-view') =='false' ? 'true' : 'false');

        if(toggled){
            $(this).text($(this).attr('data-text-toggled'));
        } else {
            $(this).text($(this).attr('data-text'));
        }

      });
  
    };
  
    init();
  
  };
  